import {getUserFromLocalStorage} from "../helper/localStorageHelper";
import {hasEuOptinValueInCookies, setGTMDataLayerUserIdTypeAndRefValue} from "../helper/analyticsHelper";
import {COOKIES_TYPES} from "../helper/cookieHelper";

document.addEventListener('DOMContentLoaded', () => {
    if (!hasEuOptinValueInCookies(COOKIES_TYPES.TARGETING)) {
        console.info('No consent given for analytics');
    }

    setGTMDataLayerUserIdTypeAndRefValue();
    displayThanksName();
});

function displayThanksName() {
    const user = getUserFromLocalStorage();
    const thanksName = document.getElementById('thanksName')
    if (!user || !user.fname) {
        console.warn("⚠️ Impossible d’afficher le prénom : utilisateur ou prénom introuvable dans le localStorage.");
        return;
    }
    if (!thanksName) {
        console.warn("⚠️ Impossible d’afficher le prénom : élément #thanksName introuvable.");
        return;
    }
    thanksName.textContent = user.fname;
}
